<template>
    <div>
        <VerifyEmailIndex
            :color="color"
            :status-validation-email="statusValidationEmail"
        />
        <component
            v-for="(component, index) in components"
            :key="index"
            :index="index"
            :is="component.name"
            :content="component"
            :total="components.length"
            home
        />
    </div>
</template>

<script>
import Banners from '../components/Common/Carousel/Carousel';
import HomeHeader from '../components/HomeComponents/HomeHeader';
import HomeLogin from '../components/HomeComponents/HomeLogin';
import HomeVideos from '../components/HomeComponents/HomeVideos';
import HomeTeam from '../components/HomeComponents/HomeTeam';
import HomeTestimonial from '../components/HomeComponents/HomeTestimonial';
import HomePlans from '../components/HomeComponents/HomePlans';
import HomePosts from '../components/HomeComponents/HomePosts';
import VerifyEmailIndex from '../components/VerifyEmail/VerifyEmailIndex';

export default {
    name: 'Home',
    components: {
        Banners,
        HomeTeam,
        HomeHeader,
        HomeLogin,
        HomeVideos,
        HomePlans,
        HomeTestimonial,
        HomePosts,
        VerifyEmailIndex,
    },
    props: {
        components: {
            type: Array,
            required: true,
        },
        color: {
            type: Object,
            required: true,
        },
        statusValidationEmail: {
            required: true,
        },
        toast: Object,
    },
    methods: {
        showToast() {
            // success
            // warning
            // info
            // error
            const message = JSON.parse(this.toast);
            this.$notify({
                type: message.status??'success',
                message: message.value??'Ok'
            });
        }
    },
    mounted() {
        if (this.toast) {
            this.showToast();
        }
    },
};
</script>

<style>

</style>
